import React, { useState, useEffect, useRef } from 'react';
import '../styles/Navbar.css';

export default function Navbar({ onResumeClick }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);

  // Close menu when clicking outside
  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setMenuOpen(false);
      }
    }
    if (menuOpen) document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  // Close menu on nav link click
  function handleNavClick() {
    setMenuOpen(false);
  }

  return (
    <nav className="navbar" ref={menuRef}>
      <a href="#hero" className="navbar__logo">Alyx Cui Edio</a>

      {/* Desktop links */}
      <ul className="navbar__links">
        <li><a href="#about">About</a></li>
        <li><a href="#skills">Skills</a></li>
        <li><a href="#experience">Experience</a></li>
        <li><a href="#education">Education</a></li>
        <li><a href="#projects">Projects</a></li>
        <li><a href="#contact">Contact</a></li>
        <li>
          <button className="navbar__resume-btn" onClick={onResumeClick}>
            Resume
          </button>
        </li>
      </ul>

      {/* Hamburger button — mobile only */}
      <button
        className={`navbar__hamburger${menuOpen ? ' is-open' : ''}`}
        onClick={() => setMenuOpen(prev => !prev)}
        aria-label="Toggle menu"
      >
        <span />
        <span />
        <span />
      </button>

      {/* Mobile dropdown menu */}
      <ul className={`navbar__mobile-menu${menuOpen ? ' is-open' : ''}`}>
        <li><a href="#about" onClick={handleNavClick}>About</a></li>
        <li><a href="#skills" onClick={handleNavClick}>Skills</a></li>
        <li><a href="#experience" onClick={handleNavClick}>Experience</a></li>
        <li><a href="#education" onClick={handleNavClick}>Education</a></li>
        <li><a href="#projects" onClick={handleNavClick}>Projects</a></li>
        <li><a href="#contact" onClick={handleNavClick}>Contact</a></li>
        <li>
          <button
            className="navbar__resume-btn"
            onClick={() => { onResumeClick(); handleNavClick(); }}
          >
            Resume
          </button>
        </li>
      </ul>
    </nav>
  );
}
